import { StatusType } from '../../components/Ad/Sections/MessageStatus/types';

interface GetStatusParams {
  isPending?: boolean | null;
  isExpired?: boolean | null;
  isLimited?: boolean | null;
  isRejected?: boolean | null;
  isExpiredManually?: boolean | null;
  isLeased?: boolean | null;
  translations?: boolean;
}

export const getStatusType = ({
  isExpired,
  isExpiredManually,
  isLeased,
  isPending,
  isLimited,
  isRejected,
  translations = false
}: GetStatusParams): StatusType => {
  switch (true) {
    case isExpired && isExpiredManually:
      if (translations) {
        if (isLeased) {
          return StatusType.ExpiredLease;
        }
        return StatusType.ExpiredSell;
      }
      return StatusType.Expired;
    case isExpired:
      return StatusType.Expired;
    case isPending:
      return StatusType.Pending;
    case isLimited:
      return StatusType.Limited;
    case isRejected:
      return StatusType.Rejected;
    default:
      return StatusType.None;
  }
};
